const getDefaultState = () => {
  return {
    forms: [],
    formId: 0,
    formZIndex: 150
  };
};

const state = getDefaultState();

const getters = {
  getForms: state => state.forms,
  getFormId: state => state.formId,
  getFormZIndex: state => state.formZIndex
};

const mutations = {
  RESET_FORMS_MODULE_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_NEW_FORM(state, form) {
    state.forms.push(form);
  },

  REMOVE_FORM_BY_ID(state, id) {
    let index = getFormIndexById(id);
    state.forms.splice(index, 1);
  },

  INCREMENT_FORM_ID(state) {
    state.formId++;
  },

  INCREMENT_FORM_Z_INDEX(state) {
    state.formZIndex++;
  },

  CHANGE_VIEW_MODE_OF_FORM(state, { formId, viewType }) {
    let index = getFormIndexById(formId);
    state.forms[index].formAction = viewType;
  },

  UPDATE_FORM_Z_INDEX_TO_FRONT(state, { formId, maxZIndex }) {
    let index = getFormIndexById(formId);
    state.forms[index].zIndex = maxZIndex;
  },

  UPDATE_FORM_TECHNICAL_POINT_DATA(state, { formID, technicalPointData }) {
    let index = getFormIndexById(formID);
    state.forms[index].technicalPointData = technicalPointData;
  }
};

const actions = {
  resetFormsModule({ commit }) {
    commit("RESET_FORMS_MODULE_STATE");
  },

  ADD_NEW_FORM({ commit }, form) {
    commit("ADD_NEW_FORM", form);
    commit("INCREMENT_FORM_ID");
    commit("INCREMENT_FORM_Z_INDEX");
  },
  REMOVE_FORM_BY_ID({ commit }, id) {
    commit("REMOVE_FORM_BY_ID", id);
  },
  CHANGE_VIEW_MODE_OF_FORM({ commit }, { formId, viewType }) {
    commit("CHANGE_VIEW_MODE_OF_FORM", { formId, viewType });
  },
  VALIDATE_IF_OBJECT_HAS_FORM_OPENED({ commit }, objectUuid) {
    return new Promise(resolve => {
      state.forms.forEach(form => {
        if (form.selectedObjectData) {
          let objectUuidKey = Object.keys(form.selectedObjectData).find(key => {
            return key.includes("uuid");
          });
          if (
            objectUuidKey &&
            form.selectedObjectData[objectUuidKey] === objectUuid
          ) {
            resolve(true);
          }
        }
      });
      resolve(false);
    });
  },
  UPDATE_FORM_Z_INDEX_TO_FRONT({ commit }, formId) {
    let maxZIndex = 150;
    state.forms.forEach(form => {
      if (form.zIndex >= maxZIndex) {
        maxZIndex = form.zIndex + 1;
      }
    });
    commit("UPDATE_FORM_Z_INDEX_TO_FRONT", { formId, maxZIndex });
    commit("INCREMENT_FORM_Z_INDEX");
  },

  updateFormTechnicalPointData({ commit }, { formID, technicalPointData }) {
    commit("UPDATE_FORM_TECHNICAL_POINT_DATA", { formID, technicalPointData });
  }
};

function getFormIndexById(id) {
  return state.forms
    .map(function(form) {
      return form.id;
    })
    .indexOf(id);
}

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/forms.js